module.exports = __webpack_public_path__ + "static/media/swf.1709f8e9.png";